<template>
    <v-container>
        <h1 class="titulo mb-3">Relatório de Logs Expurgados</h1>
        <v-card>
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ rotate90: filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" class="mt-8" v-show="filter_open">
                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <DateRange :not-after-today-habilitado="true" v-model="filters.dataRange" @filter="filtrar() "
                                           :shortcut="true" label="Data de execução de expurgo" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select clearable id="FieldCategoria" label="Tipo de Execução: " outlined menu-props="offsetY" :items="categorias" hide-details v-model="filters.categoria" placeholder="Selecione o Tipo de Execução" item-text="name" item-value="value" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <p class="text--darkgray">Quantidade de logs excluídos: </p>
                                <v-range-slider
                                        v-model="filters.range_logs_excluidos"
                                        :min="limitesFiltro.min_logs_excluidos"
                                        :max="limitesFiltro.max_logs_excluidos"
                                        :step="stepSizeArquivosApagados"
                                        color="secondary"
                                        track-color="gray"
                                        track-fill-color="secondary">
                                    <template v-slot:thumb-label="param">
                                        <span class="pa-5">{{ param.value }}</span>
                                    </template>
                                </v-range-slider>
                                <div class="d-flex justify-space-between">
                                    <p style="width: 70px">{{ limitesFiltro.min_logs_excluidos }}</p>
                                    <p style="width: 70px" class="text-end">{{ limitesFiltro.max_logs_excluidos }}</p>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6">
                                <p class="text--darkgray">Espaço em disco liberado (MB): </p>
                                <v-range-slider
                                        v-model="filters.range_espaco_disco_liberado"
                                        :min="limitesFiltro.min_espaco_disco_liberado"
                                        :max="limitesFiltro.max_espaco_disco_liberado"
                                        :step="stepSizeEspacoDisco"
                                        color="secondary"
                                        track-color="gray"
                                        track-fill-color="secondary">
                                    <template v-slot:thumb-label="param">
                                        <span>{{ param.value }}</span>
                                    </template>
                                </v-range-slider>
                                <div class="d-flex justify-space-between">
                                    <p style="width: 70px">{{ limitesFiltro.min_espaco_disco_liberado }}</p>
                                    <p style="width: 70px" class="text-end">{{ limitesFiltro.max_espaco_disco_liberado }}</p>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select clearable id="FieldStatus" label="Status: " outlined menu-props="offsetY" :items="status" hide-details v-model="filters.status" placeholder="Selecione o Status" item-text="name" item-value="value" />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-col cols="6" sm="3">
                                <v-btn color="secondary" block @click="limparFiltro">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3">
                                <v-btn color="primary" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <br />
                <DataTable url="/painel/expurgo_de_logs/listar_expurgos" :headers="headers" :params="params" item-key="id" class="listagem text-center" ref="datatable" :filter="search">
                    <template v-slot:items="{item}">
                        <td>{{ item.data_expurgo | toDateTimeBR }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ item.tipo_execucao }}</td>
                        <td>{{ item.quantidade_logs_excluidos || '-' }}</td>
                        <td>{{ item.espaco_disco_liberado ? `${item.espaco_disco_liberado} MB` : '-' }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
        <br />
    </v-container>
</template>
<script>
  import * as Qs from 'qs'

  export default {
    name: 'RelatoriosExpurgoLogs',
    data: () => ({
      headers: [
        { text: 'Data do expurgo', value: 'data_expurgo', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Tipo de Execução', value: 'tipo_execucao', align: 'center' },
        { text: 'Quantidade de logs excluídos', value: 'quantidade_logs_excluidos', align: 'center' },
        { text: 'Espaço em disco liberado (MB)', value: 'espaco_disco_liberado', align: 'center' }
      ],
      custom_filter: {},
      filter_open: false,
      filters: {
        dataRange: ['', ''],
        categoria: '',
        status: '',
        range_logs_excluidos: [0, 0],
        range_espaco_disco_liberado: [0, 0]
      },
      limitesFiltro: {
        min_logs_excluidos: 0,
        max_logs_excluidos: 100,
        min_espaco_disco_liberado: 0,
        max_espaco_disco_liberado: 1000
      },
      search: {},
      items: [],
      categorias: ['Manual', 'Automático'],
      status: ['Finalizado', 'Iniciado', 'Falha']
    }),
    computed: {
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'data_expurgo',
            descending: true,
            totalItems: 0
          },
          custom_filter: this.customFilter
        }
      },
      stepSizeEspacoDisco () {
        const min = this.limitesFiltro.min_espaco_disco_liberado
        const max = this.limitesFiltro.max_espaco_disco_liberado
        const step = Math.round((max - min) * 0.02)
        if (step < 1) {
          return 1
        }
        return step
      },
      stepSizeArquivosApagados () {
        const min = this.limitesFiltro.min_logs_excluidos
        const max = this.limitesFiltro.max_logs_excluidos
        const step = Math.round((max - min) * 0.02)
        if (step < 1) {
          return 1
        }
        return step
      }
    },
    mounted () {
      Promise.all([this.getLimitesPrazos()])
    },
    methods: {
      async getLimitesPrazos () {
        await this.$http.get('/painel/historico_expurgo_logs/get_limites_filtro').then(({ status_code, data }) => {
          Object.assign(this.limitesFiltro, data.limites)
          this.filters.range_logs_excluidos = [this.limitesFiltro.min_logs_excluidos, this.limitesFiltro.max_logs_excluidos]
          this.filters.range_espaco_disco_liberado = [this.limitesFiltro.min_espaco_disco_liberado, this.limitesFiltro.max_espaco_disco_liberado]
        }).catch(() => {
          // Não exibir erro manter os padrões, necessário o catch para o axios não pegar o erro
        })
      },
      downloadReport () {
        const encoded_params = Qs.stringify({
          filter: this.search,
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/expurgo_de_logs/download?${encoded_params}`)
      },
      limparFiltro () {
        this.search = {}
        this.$refs.datatable.reload()
        this.$refs.filter.reset()
        this.filters.dataRange = ['', '']
        this.filters.range_logs_excluidos = [this.limitesFiltro.min_logs_excluidos, this.limitesFiltro.max_logs_excluidos]
        this.filters.range_espaco_disco_liberado = [this.limitesFiltro.min_espaco_disco_liberado, this.limitesFiltro.max_espaco_disco_liberado]
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          this.search = { ...this.filters }
        }
      }
    }
  }
</script>
<style scoped>

.cursor-pointer {
  font-size: 26px!important
}
</style>
